import React, { useContext } from 'react';
import S from "./Returns";
import CardHeader from "../CardHeader";
import FundContext from '@/components/FundSingle/FundProvider';
import Table from "../../../Table/index";
import moment from 'moment';

const Returns: React.FC<FundSingle> = ({short = false}) => {
    const { fundRiskDetails } = useContext(FundContext);
    
    if (!fundRiskDetails) return null;

    const getValuesFromPerformance = (returns: any, timePeriod: string) => {
        if (!Array.isArray(returns)) return '-';

        const navItem = returns.find((item: any) => item?.ReturnType === 'Nav');
        if (!navItem || !Array.isArray(navItem.Return)) return '-';

        const timePeriodItem = navItem.Return.find((item: any) => item?.TimePeriod === timePeriod);
        if (!timePeriodItem || typeof timePeriodItem.Value !== 'number') return '-';

        return timePeriodItem.Value.toFixed(2);
    };

    var date = moment(fundRiskDetails.TrailingPerformance.Date).format('YYYY-MM-DD');
    var trailingPerformance = fundRiskDetails.TrailingPerformance;
    var benchMarkTrailingPerformance = fundRiskDetails.Benchmark.find((b) => b.Type == 'Category').TrailingPerformance;
    var hasBenchmark = benchMarkTrailingPerformance !== undefined;

    if (short) {
        var tableValues = {
            "Hittills i år": [
                getValuesFromPerformance(trailingPerformance, 'M12'),
                ...(hasBenchmark ? [getValuesFromPerformance(benchMarkTrailingPerformance, 'M12')] : []),
            ],
            "3 år medel": [
                getValuesFromPerformance(trailingPerformance, 'M36'),
                ...(hasBenchmark ? [getValuesFromPerformance(benchMarkTrailingPerformance, 'M36')] : []),
            ],
            "5 år medel": [
                getValuesFromPerformance(trailingPerformance, 'M60'),
                ...(hasBenchmark ? [getValuesFromPerformance(benchMarkTrailingPerformance, 'M60')] : []),
            ],
            "10 år annualiserat": [
                getValuesFromPerformance(trailingPerformance, 'M120'),
                ...(hasBenchmark ? [getValuesFromPerformance(benchMarkTrailingPerformance, 'M120')] : []),
            ]
        };
    }
    else {
        var tableValues = {
            "1 dag": [
                getValuesFromPerformance(trailingPerformance, 'D1'),
                ...(hasBenchmark ? [getValuesFromPerformance(benchMarkTrailingPerformance, 'D1')] : []),
            ],
            "1 vecka": [
                getValuesFromPerformance(trailingPerformance, 'W1'),
                ...(hasBenchmark ? [getValuesFromPerformance(benchMarkTrailingPerformance, 'W1')] : []),
            ],
            "1 månad": [
                getValuesFromPerformance(trailingPerformance, 'M1'),
                ...(hasBenchmark ? [getValuesFromPerformance(benchMarkTrailingPerformance, 'M1')] : []),
            ],
            "3 månader": [
                getValuesFromPerformance(trailingPerformance, 'M3'),
                ...(hasBenchmark ? [getValuesFromPerformance(benchMarkTrailingPerformance, 'M3')] : []),
            ],
            "6 månader": [
                getValuesFromPerformance(trailingPerformance, 'M3'),
                ...(hasBenchmark ? [getValuesFromPerformance(benchMarkTrailingPerformance, 'M3')] : []),
            ],
            "Hittills i år": [
                getValuesFromPerformance(trailingPerformance, 'M12'),
                ...(hasBenchmark ? [getValuesFromPerformance(benchMarkTrailingPerformance, 'M12')] : []),
            ],
            "3 år medel": [
                getValuesFromPerformance(trailingPerformance, 'M36'),
                ...(hasBenchmark ? [getValuesFromPerformance(benchMarkTrailingPerformance, 'M36')] : []),
            ],
            "5 år medel": [
                getValuesFromPerformance(trailingPerformance, 'M60'),
                ...(hasBenchmark ? [getValuesFromPerformance(benchMarkTrailingPerformance, 'M60')] : []),
            ],
            "10 år annualiserat": [
                getValuesFromPerformance(trailingPerformance, 'M120'),
                ...(hasBenchmark ? [getValuesFromPerformance(benchMarkTrailingPerformance, 'M120')] : []),
            ]
        };

    }

    var tableData = {
        headings: ['', 'FOND', ...(hasBenchmark ? ['KATEG.'] : [])],
        rows: tableValues
    }

    return (
        <S.AllocationWrapper>
            <CardHeader title="Avkastning % (SEK)" subTitle={date} />
            <Table tableData={tableData} />
        </S.AllocationWrapper>
    );
};

export default Returns;
